<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
/* message.css */
.custom-message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);
  opacity: 0;
  padding: 12px 20px;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  z-index: 9999;
  transition: all 0.3s ease;
  pointer-events: none;
}

.custom-message-success {
  background-color: #52c41a;
}
.custom-message-error {
  background-color: #ff4d4f;
}
.custom-message-info {
  background-color: #1890ff;
}

</style>
